import React from 'react';
import useManualRefinement from '../Controller/useRandomSampler.controller';
import {ContainerBox, EmptyBox, EmptyP, ResponsiveBox} from '../Style/RandomSampler.style';
import ManualRefinementImageList from '../../../Containers Components/ManualRefinementImageList/View/ManualRefinementImageList.view';
import {ThemeProvider} from '../../../ui-library';
import WrongRequest from '../../ManualRefinement/View/WrongRequest.view';
import RandomSamplerClasses from '../../../Containers Components/RandomSamplerClasses/View/RandomSamplerClasses.view';
import {FLOW} from '../Config/RandomSampler.constants';
import emptyIcon from '../../../images/empty_projects.png';
import {_SYSTEM_TITLES} from '../../../configuration/SystemTitles/SystemTitles.config';

const RandomSampler = () => {
    const {goBackToObjectsTab, randomSamplerState, setState, getRandomSamplerData, disableDelete, addImageToClassReference} = useManualRefinement(FLOW.randomImages);

    return (
        <ThemeProvider>
            <ContainerBox>
                {<ResponsiveBox
                    sx={{
                        flexDirection: {xs: 'column-reverse', md: 'row'},
                        alignItems: {lg: 'flex-start'}
                    }}>
                    <>
                        {randomSamplerState.isErrorPage ? <WrongRequest/>
                            : <>
                                {!randomSamplerState.isEmpty ? <ManualRefinementImageList
                                    disableDelete={disableDelete}
                                    isChoseAnotherClass={false}
                                    setState={setState}
                                    manualRefinementState={randomSamplerState}
                                    isGlobalLoading={randomSamplerState.globalLoading}
                                    key='ManualRefinementImageList'
                                    flow={FLOW.randomImages}
                                /> : <EmptyBox>
                                    <img src={emptyIcon} alt={'empty images'} width={185}/>
                                    <EmptyP>{_SYSTEM_TITLES.mrEmptyTitle}</EmptyP>
                                </EmptyBox>}
                            </>}
                        <RandomSamplerClasses
                            addImageToClassReference={addImageToClassReference}
                            getRandomSamplerData={getRandomSamplerData}
                            classes={randomSamplerState.classes}
                            goBackToObjectsTab={goBackToObjectsTab}
                            randomSamplerState={randomSamplerState}
                            setState={setState}
                        />
                    </>
                </ResponsiveBox>}
            </ContainerBox>
        </ThemeProvider>
    );

};

export default RandomSampler;
